import * as React from "react";
import SvgIcon, { SvgIconProps } from "material-ui/SvgIcon";

export class BuetzerBuebeLogo extends React.Component<SvgIconProps, undefined> {
  render() {
    const props = Object.assign(
      { viewBox: "0 0 1024 1024", color: "black" },
      this.props,
    );

    return (
      <div />
    );
  }
}

export default BuetzerBuebeLogo;



// WEBPACK FOOTER //
// ./src/themes/buetzerBuebeTheme/components/BuetzerBuebeLogo.tsx